import React, { Component } from 'react';
import { Input, Icon } from 'antd';

import { inject, observer } from 'mobx-react';

import { MagnifierIcon } from '../../../../../common/icons';

import './FullTextSearch.css';

@inject('subscriptionsStore', 'filterStore')
@observer
export default class FullTextSearch extends Component {
  componentWillUnmount = () => {
    this.emitEmpty();
  };

  search = () => {
    const { filterStore, subscriptionsStore } = this.props;
    filterStore.add(`textSubscription`, subscriptionsStore.textSearchFns(filterStore.fullTextSearch));
    filterStore.apply();
  };

  keyPress = e => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  emitEmpty = () => {
    const { filterStore } = this.props;
    filterStore.fullTextSearch = null;
    filterStore.remove(`textSubscription`);
    filterStore.apply();
  };

  onChange = e => {
    this.props.filterStore.fullTextSearch = e.target.value;
  };

  render() {
    const suffix = this.props.filterStore.fullTextSearch ? <Icon type="close-circle" onClick={this.emitEmpty} style={{ color: 'white' }} /> : null;
    return (
      <div className="FullTextSearch">
        <Input
          placeholder={this.props.placeholder}
          prefix={<MagnifierIcon onClick={this.search} />}
          value={this.props.filterStore.fullTextSearch}
          onChange={this.onChange}
          onKeyDown={this.keyPress}
          suffix={suffix}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubHeader/FullTextSearch/FullTextSearch.js